import { Router } from '@angular/router';

export async function navigateToCurrentUrl(router: Router): Promise<boolean> {
	return await router.navigateByUrl(router.url, {
		skipLocationChange: false,
		replaceUrl: true,
		onSameUrlNavigation: 'reload',
	});
}
